import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export interface RecoveryUser {
  id?: number;
  email?: string;
  [key: string]: unknown;
}

export interface RecoveryTokenResponse extends RecoveryUser {
  tag?: string;
}

export interface ChangePasswordResponse {
  code?: number;
  details?: string;
}

@Injectable({ providedIn: 'root' })
export class RecoveryService {
  private readonly http = inject(HttpClient);

  validateToken(token: string) {
    const url = `${environment.customerPath}users/recovery`;
    const params = new HttpParams().set('token', token);

    return this.http.get<RecoveryTokenResponse>(url, { params });
  }

  changePassword(token: string, user: RecoveryUser, password: string) {
    const url = `${environment.customerPath}users/recovery/${token}/password`;

    return this.http.put<ChangePasswordResponse>(url, { user, password: password.toString() });
  }
}
